import React from 'react';
import { ArrowUp } from 'lucide-react';
export function Footer() {
  const scrollToTop = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="py-8 px-6 md:px-12 bg-bg border-t border-border" data-id="element-50">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-51">
        <p className="font-sans text-sm text-text-muted" data-id="element-52">
          © {new Date().getFullYear()} Elena UX. All rights reserved.
        </p>

        <a href="#top" onClick={scrollToTop} className="flex items-center gap-2 text-sm font-medium text-text-muted hover:text-accent transition-colors" data-id="element-53">
          Back to top <ArrowUp size={16} data-id="element-54" />
        </a>
      </div>
    </footer>;
}